export default __webpack_public_path__ + "static/media/vikingcute.ef43d821.png";